import { render } from "./OrderAssignToUser.vue?vue&type=template&id=20f95e5d&ts=true"
import script from "./OrderAssignToUser.ts?vue&type=script&lang=ts"
export * from "./OrderAssignToUser.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__